import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { StageService } from 'pages/system-fields/stages/service';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, creatTableButton } from 'resources/utility';
import toastr from 'toastr';

@inject(StageService, DialogService, EventAggregator)
export class Stages {
    constructor(stageService, dialogService, ea) {
        this.ea = ea;
        this.stageService = stageService;
        this.dialogService = dialogService;

        const workCenterLoopup = [
            { id: 0, value: 'STAMPING' },
            { id: 1, value: 'WELDING' },
            { id: 2, value: 'OTHER' }
        ];

        this.columns = [
            { dataField: 'name', sortOrder: 'asc', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { dataField: 'processName', caption: 'Process' },
            { dataField: 'workCenter', lookup: { dataSource: workCenterLoopup, valueExpr: 'id', displayExpr: 'value' } },
            { caption: 'Actions', cellTemplate: (container, options) => creatTableButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete }), allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('stages:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (stage) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.stageService.delete(stage.id);
                this.grid.refresh();
                toastr.success('Stage was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: this.stageService.editor });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.stageService.editor, model: { id: data.id } });
    };
}